import { Component, OnInit, computed, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoadingSpinner } from 'design-system';
import { NewCustomerService } from '../../../services/new-customer.service';

// Dettaglio dell'azienda nel Registro delle Imprese, con la scelta
@Component({
  selector: 'ord-new-customer-company-detail',
  imports: [LoadingSpinner, MatButtonModule, MatExpansionModule],
  templateUrl: './new-customer-company-detail.html',
  styleUrl: './new-customer-company-detail.scss',
})
export class NewCustomerCompanyDetail implements OnInit {
  readonly flow = inject(NewCustomerService);
  private readonly snackBar = inject(MatSnackBar);

  readonly failed = signal(false);

  // Il dettaglio in memoria vale solo se è dell'azienda scelta
  readonly detail = computed(() => {
    const company = this.flow.company();
    const detail = this.flow.detail();
    return company && detail?.companyId === company.companyId ? detail : null;
  });

  ngOnInit(): void {
    const company = this.flow.company();
    if (company && !this.detail()) {
      this.flow.loadCompany(company).subscribe({ error: () => this.failed.set(true) });
    }
  }

  confirm(): void {
    const company = this.flow.company();
    if (!company || this.flow.loading()) {
      return;
    }

    this.flow.confirmCompany(company).subscribe({
      error: (error: unknown) => {
        const message = this.flow.errorMessage(error);
        if (message) {
          this.snackBar.open(message, 'Chiudi', { duration: 5000 });
        }
      },
    });
  }
}
